export const state = {
    weburl:window.location.protocol + "//www.chuanloo.com/",                   //长鹿官网url
    // weburl:window.location.protocol + "//s.tpshop.com/",                       //陈卓电脑
    // weburl:"http://s.indoorlink.com/",                                         //测试服务器
    // weburl:"http://192.168.0.97/changlu/",                                     //小彬电脑
    // weburl:"http://192.168.0.96/",
    hurl:"Home",                                                                  //拼接在域名后的路径
};

